import { Pipe, PipeTransform } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Dictionary } from '@ngrx/entity'
import { Product } from '../../../product/product'

@Pipe({
  name: 'isDependantProductSelected'
})
export class IsDependantProductSelectedPipe implements PipeTransform {
  transform(
    formProducts: any,
    productId: number,
    productEntities: Dictionary<Product>
  ) {
    if (!formProducts) {
      console.warn(`productForm is null for productId: ${productId}`)
      return false
    }
    // const dependantProducts = productEntities[productId].dependantProducts
    let dependantProducts = productEntities
      ? [...(productEntities[productId].dependantProducts ?? [])]
      : []
    // productEntities[productId].dependantProducts.map((item) => {
    //   dependantProducts = [
    //     ...dependantProducts,
    //       ...productEntities[item].dependantProducts
    //   ]
    // })
    dependantProducts = [...new Set(dependantProducts)].filter(
      (item) => item != productId
    )
    if (!dependantProducts || dependantProducts.length === 0) {
      return false
    }

    const selectedProducts: number[] = formProducts
      ?.filter((p) => p.selected)
      .map((p) => p.bookableProductId)

    if (!selectedProducts || selectedProducts.length === 0) {
      return false
    }

    return dependantProducts.some((p) => selectedProducts.includes(p))
  }
}
